<template>
  <div>
    <h6>Type</h6>
    <div class="grid">
      <dropdown
        :options="type_options"
        :value="project.type"
        :onChange="val => (project.type = val)"
        placeholder="Project type"
      />
    </div>

    <div v-if="project.type === 'Tender' || project.type === 'Negotiation'">
      <h6 class="spaced">Key dates</h6>
      <div class="grid">
        <div class="datepicker" v-if="project.type === 'Tender'">
          <label>RFP release date</label>
          <datepicker
            :value="project.rfpReleaseDate"
            mode="single"
            :onChange="updateReleaseDate"
            placeholder="Select date"
            class="datepicker"
          />
        </div>

        <div class="datepicker" v-if="project.type === 'Tender'">
          <label>Responses due</label>
          <datepicker
            :value="project.rfpResponsesDueDate"
            mode="single"
            :onChange="updateResponsesDate"
            placeholder="Select date"
            class="datepicker"
          />
        </div>

        <div class="datepicker">
          <label>Negotiation plan completed</label>
          <datepicker
            :value="project.negPlanCompleted"
            mode="single"
            :onChange="updateNegDate"
            placeholder="Select date"
            class="datepicker"
          />
        </div>

        <div class="datepicker">
          <label>Anticipated award date</label>
          <datepicker
            :value="project.anticipatedAwardDate"
            mode="single"
            :onChange="updateAwardDate"
            placeholder="Select date"
            class="datepicker"
          />
        </div>
      </div>
    </div>

    <div v-if="project.type === 'Contract Renewal'">
      <h6 class="spaced">Key dates</h6>
      <div class="grid">
        <div class="datepicker">
          <label>Anticipated renewal date</label>
          <datepicker
            :value="project.anticipatedRenewalDate"
            mode="single"
            :onChange="updateRenewalDate"
            placeholder="Select date"
            class="datepicker"
          />
        </div>
      </div>
    </div>

    <div v-if="project.type === 'Exit'">
      <h6 class="spaced">Key dates</h6>
      <div class="grid">
        <div class="datepicker">
          <label>Anticipated notice date</label>
          <datepicker
            :value="project.anticipatedNoticeDate"
            mode="single"
            :onChange="updateNoticeDate"
            placeholder="Select date"
            class="datepicker"
          />
        </div>

        <div class="datepicker">
          <label>Anticipated exit date</label>
          <datepicker
            :value="project.anticipatedExitDate"
            mode="single"
            :onChange="updateExitDate"
            placeholder="Select date"
            class="datepicker"
          />
        </div>
      </div>
    </div>

    <div>
      <h6
        :class="{ spaced: ['Other', 'Self-Service'].includes(project.type) }"
        v-if="project.type !== 'Process Review'"
      >
        {{ supplier_final_label }}
      </h6>
      <div
        class="grid"
        v-if="project.type !== 'Process Review'"
      >
        <data-select
          type="suppliers"
          :changeHandler="updateSuppliers"
          :filterIds="supplier_final_keys"
          arg="Final"
          allowAdd
        />

        <data-select
          type="suppliers"
          v-for="(supplier, index) of project_suppliers"
          :key="`supplier-final-${index}`"
          :changeHandler="updateSuppliers"
          :value="supplier"
          :filterIds="supplier_final_keys"
          arg="Final"
        />
      </div>

      <h6
        class="spaced"
        v-if="
          project.type !== 'Contract Renewal' &&
            project.type !== 'Process Review' &&
            project.type !== 'Negotiation' &&
            project.type !== 'Exit'
        "
      >
        {{ supplier_awarded_label }}
      </h6>
      <div
        class="grid"
        v-if="
          project.type !== 'Contract Renewal' &&
            project.type !== 'Process Review' &&
            project.type !== 'Negotiation' &&
            project.type !== 'Exit'
        "
      >
        <data-select
          type="suppliers"
          :changeHandler="updateSuppliers"
          :filterIds="supplier_awarded_keys"
          arg="Selected"
        />

        <data-select
          type="suppliers"
          v-for="(supplier, index) of project_suppliers_awarded"
          :key="`supplier-awarded-${index}`"
          :changeHandler="updateSuppliers"
          :value="supplier"
          :filterIds="supplier_awarded_keys"
          arg="Selected"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import DataSelect from './DataSelect.vue';
import Datepicker from './Datepicker';
import Dropdown from './Dropdown';
import moment from 'moment';

export default {
  name: 'ProjectModal_Type',
  data() {
    return {
      type_options: [
        { value: 'Tender', text: 'Tender' },
        { value: 'Contract Renewal', text: 'Contract Renewal' },
        { value: 'Negotiation', text: 'Negotiation' },
        { value: 'Exit', text: 'Exit' },
        { value: 'Process Review', text: 'Process Review' },
        { value: 'Self-Service', text: 'Self-Service' },
        { value: 'Other', text: 'Other' },
      ],
    };
  },
  computed: {
    project_id() {
      return this.$store.getters.project_modal_id;
    },
    all_suppliers() {
      return Object.keys(this.$store.getters.suppliers).map(key => {
        return Number(this.$store.getters.suppliers[key].id);
      });
    },
    supplier_final_keys() {
      if (!this.project || !this.project.projectSuppliers) return [];
      return this.project.projectSuppliers.map(supplier => supplier.supplierId);
    },
    supplier_awarded_keys() {
      return this.all_suppliers.filter(s => {
        const the_supplier = this.project_suppliers.find(
          supplier => supplier.supplierId === s
        );
        const is_awarded = the_supplier && the_supplier.type === 'Selected';

        return !the_supplier || is_awarded;
      });
    },
    project_suppliers() {
      return this.project.projectSuppliers;
    },
    project_suppliers_awarded() {
      return this.project_suppliers.filter(supplier => {
        return supplier.type === 'Selected';
      });
    },
    project_supplier_keys() {
      return this.project.projectSuppliers.map(supplier => supplier.supplierId);
    },
    supplier_final_label() {
      switch (this.project.type) {
        case 'Contract Renewal':
          return 'Incumbent suppliers';
        case 'Exit':
          return 'Exiting suppliers';
        case 'Negotiation':
          return 'Suppliers';
        default:
          return 'Suppliers final stage';
      }
    },
    supplier_awarded_label() {
      switch (this.project.type) {
        case 'Contract Renewal':
          return 'Incumbent suppliers';
        default:
          return 'Suppliers awarded';
      }
    },
  },
  props: {
    project: Object,
  },
  components: {
    'data-select': DataSelect,
    dropdown: Dropdown,
    datepicker: Datepicker,
  },
  methods: {
    updateSuppliers(supplier, mode, type, old_value) {
      supplier.type = type;

      if (mode === 'add') {
        if (old_value && type === 'Selected') {
          this.replaceSupplierSelected(supplier, mode, type, old_value);
        } else if (old_value && type === 'Final') {
          this.replaceSupplierFinal(supplier, mode, type, old_value);
        } else if (this.project_supplier_keys.includes(supplier.id)) {
          this.addNewSupplierSelected(supplier, mode, type, old_value);
        } else {
          this.addNewSupplierFinal(supplier, mode, type, old_value);
        }
      } else {
        if (type === 'Selected') {
          this.removeSupplierSelected(supplier, mode, type, old_value);
        } else {
          this.removeSupplierFinal(supplier, mode, type, old_value);
        }
      }
    },
    addNewSupplierFinal(supplier, mode, type, old_value) {
      this.project.projectSuppliers.push(Object.assign({}, supplier));
    },
    addNewSupplierSelected(supplier, mode, type, old_value) {
      this.project_supplier_keys.forEach((key, index) => {
        if (key === supplier.supplierId) {
          Vue.set(this.project.projectSuppliers[index], 'type', 'Selected');
        }
      });
    },
    replaceSupplierFinal(supplier, mode, type, old_value) {
      this.project.projectSuppliers.forEach((s, index) => {
        if (s.supplierId === old_value.supplierId) {
          Vue.set(this.project.projectSuppliers, index, supplier);
        }
      });
    },
    replaceSupplierSelected(supplier, mode, type, old_value) {
      this.project.projectSuppliers.forEach((s, index) => {
        if (s.supplierId === old_value.supplierId) {
          Vue.set(this.project.projectSuppliers[index], 'type', 'Final');
        }

        if (s.supplierId === supplier.supplierId) {
          Vue.set(this.project.projectSuppliers[index], 'type', 'Selected');
        }
      });
    },
    removeSupplierSelected(supplier, mode, type, old_value) {
      this.project.projectSuppliers.forEach((s, index) => {
        if (s.supplierId === supplier.supplierId) {
          Vue.set(this.project.projectSuppliers[index],'type', 'Final');
        }
      });
    },
    removeSupplierFinal(supplier, mode, type, old_value) {
      this.project.projectSuppliers = this.project.projectSuppliers.filter(
        s => s.supplierId !== supplier.supplierId
      );
    },
    updateDate(date, key) {
      if (date) {
        const new_date = moment(date);
        const old_date = moment(this.project[key]);

        if (new_date && old_date && !new_date.isSame(old_date, 'd')) {
          Vue.set(this.project, key, new_date.toISOString());
        }
      } else {
        Vue.set(this.project, key, null);
      }
    },
    updateReleaseDate(date) {
      this.updateDate(date, 'rfpReleaseDate');
    },
    updateResponsesDate(date) {
      this.updateDate(date, 'rfpResponsesDueDate');
    },
    updateNegDate(date) {
      this.updateDate(date, 'negPlanCompleted');
    },
    updateAwardDate(date) {
      this.updateDate(date, 'anticipatedAwardDate');
    },
    updateRenewalDate(date) {
      this.updateDate(date, 'anticipatedRenewalDate');
    },
    updateNoticeDate(date) {
      this.updateDate(date, 'anticipatedNoticeDate');
    },
    updateExitDate(date) {
      this.updateDate(date, 'anticipatedExitDate');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';
</style>
